import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationAuthenticateArgs, BackendUserAuthStatus } from 'src/types/backend';

const MUTATION = gql`
  mutation Authenticate($email: String!, $password: String!, $device: String) {
    authenticate(email: $email, password: $password, device: $device) {
      token
    }
  }
`;

type Variables = BackendMutationAuthenticateArgs;
type Result = BackendUserAuthStatus;

export const authenticate = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
